import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import { Formik, useFormikContext } from "formik";
import { useEffect, useMemo, useRef, useState } from 'react';
import * as yup from 'yup';
import MobileSearchControl from "../controls/mobileSearchControl";
import NationalityDropdown, { INationality } from '../controls/nationality/NationalityDropdown';
import { resolveNationalityOptions } from '../controls/nationality/nationalityHelper';
import NewMobileAddRoom from '../controls/newMobileAddRoom';
import PromotionMobile from "../controls/promotion/promotionMobile";
import RangeDateControl from "../controls/RangeDateControl/RangeDateControl";
import Toast from "../controls/toast";
import { Features, IsFeatureEnabled } from "../featureFlag";
import { getIBE_API } from '../getAPIUrl';
import { getWidgetSessionToken, ibeAuthenticatedFetch } from '../ibeAuth';
import { cityCodeMapping } from "../utility/enum/cityCodeEnums";
import { PromotionEnum } from "../utility/enum/promotionEnum";
import { PromotionEnumKey } from "../utility/enum/promotionEnumKey";
import { StayType } from "../utility/enum/stayTypeEnum";
import { parseDateISOFormat } from '../utility/function/date';
import { getLocaleFromUrl, useTranslation } from "../utility/function/useTranslations";
import { useIbeChatWidget } from '../hooks/useIbeChatWidget';
import { bookNowHandler } from "./WidgetHelper";
import './WidgetStyle.css';

function ReservationWidgetMobile(props: any) {
  const brandID = props?.props?.symbol?.brandid;
  const chainID = props?.props?.symbol?.chainid;
  const openinNewTab = !(props?.props?.symbol?.openinnewtab === 'false');
  const cityCodeDemand = props?.props?.symbol?.citycodedemand;
  const currencyMappingData = props?.props?.symbol?.currencymappingdata ? JSON.parse(props?.props?.symbol?.currencymappingdata) : [];
  const isMultiCurrencyFFEnable = props?.props?.symbol?.ismulticurrencyffenable;
  const preferredCurrency = props?.props?.symbol?.preferredcurrency ? JSON.parse(props?.props?.symbol?.preferredcurrency) : {};
  const destination: { location: string, type: number, id: string } = props?.props?.symbol?.destination ? JSON.parse(props?.props?.symbol?.destination) : null;
  const guest = props?.props?.symbol?.guest ? JSON.parse(props?.props?.symbol?.guest).map((ele: any) => { return { roomCount: ele.RoomNo, adultCount: ele.Adult, childCount: ele.Child } }) : [{ "roomCount": 1, "adultCount": brandID === 'cfd8297c-a349-4f17-999b-8f5837abed81' ? 1 : 2, "childCount": 0 }];
  const urlCheckInDate = props?.props?.symbol?.checkindate;
  const urlCheckOutDate = props?.props?.symbol?.checkoutdate;
  const showSearch = props?.props?.symbol?.search;
  const backgroundColor1 = props?.props?.symbol?.backgroundprimarycolor;
  const backgroundColor2 = props?.props?.symbol?.backgroundprimarycolor;
  var booknowbuttoncolor = props?.props?.symbol?.widgetsearchcolorbutton || props?.props?.symbol?.booknowbuttoncolor;
  booknowbuttoncolor = (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477' : `${booknowbuttoncolor}`
  var booknowbuttonhovercolor = props?.props?.symbol?.widgetsearchcolorhoverstate || props?.props?.symbol?.booknowbuttoncolor;
  booknowbuttonhovercolor = (booknowbuttonhovercolor == undefined || booknowbuttonhovercolor == null || booknowbuttonhovercolor == 'null') ? '#546477' : booknowbuttonhovercolor;
  const widgetFontColor = props?.props?.symbol?.widgetfontcolor;
  var widgetSearchFontButtonColor = props?.props?.symbol?.widgetsearchfontcolorbutton;
  widgetSearchFontButtonColor = (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff' : `${widgetSearchFontButtonColor}`;
  var widgetSearchFontHoverStateColor = props?.props?.symbol?.widgetsearchfontcolorhoverstate;
  widgetSearchFontHoverStateColor = (widgetSearchFontHoverStateColor == undefined || widgetSearchFontHoverStateColor == null || widgetSearchFontHoverStateColor == 'null') ? '#fff' : `${widgetSearchFontHoverStateColor}`;
  const promotion = props?.props?.symbol?.promotion ? JSON.parse(props?.props?.symbol?.promotion) : null;
  const dataStayType = props?.props?.symbol?.staytype;
  const isModify = props?.props?.symbol?.ismodify;
  //console.logg("ReservationWidgetMobile  isModify:", isModify)
  const [formValues, setFormValues] = useState<any>()
  const [stayType, setStayType] = useState<StayType>(dataStayType ? dataStayType === StayType.DAY_USE ? StayType.DAY_USE : StayType.OVERNIGHT : StayType.OVERNIGHT);
  const [isDayBookingEnabled, setIsDayBookingEnabled] = useState<boolean>(false);
  const [isDayBookingLoading, setIsDayBookingLoading] = useState<boolean>(true);
  const [isNationalityEnabled, setIsNationalityEnabled] = useState<boolean>(false);
  const [nationalityData, setNationalityData] = useState<INationality[]>([]);
  const [selectedNationality, setSelectedNationality] = useState<INationality | null>(null);
  const [nationalityError, setNationalityError] = useState<boolean>(false);
  var showSelectedRate = props?.props?.symbol?.showselectedrate ? props?.props?.symbol?.showselectedrate.toLowerCase() === 'true' : true;
  var showGuest = props?.props?.symbol?.showguest ? props?.props?.symbol?.showguest.toLowerCase() === 'true' : true;
  var showDestinationSearch = props?.props?.symbol?.showdestinationsearch ? props?.props?.symbol?.showdestinationsearch.toLowerCase() === 'true' : true;
  const [locale, setLocale] = useState<string>('en');

  useEffect(() => {
    if (brandID) {
      if (props?.props?.symbol?.locale) {
        setLocale(props?.props?.symbol?.locale);
      } else {
        setLocale(getLocaleFromUrl(brandID) || 'en');
      }
    }
  }, [brandID]);

  // Prefetch short-lived session token (minted server-side via /Session/issueBrowser)
  useEffect(() => {
    if (brandID && chainID) {
      void getWidgetSessionToken(brandID, chainID);
    }
  }, [brandID, chainID]);

  let today: any = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
  const checkInDate = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0');
  const defaultPropCode = props?.props?.symbol?.defaultpropcode;
  const disableSearchControl = props?.props?.symbol?.disablesearchcontrol;
  // Get the day and month
  const currentDay = today.getDate();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  // Increment the current date by one day to get the next date
  let nextDate: any = new Date(currentYear, currentMonth, currentDay + 1);
  // // Adjust the month if needed (case: last day of the month)
  // if (nextDate.getMonth() !== currentMonth) {
  //   nextDate  = new Date(currentYear, currentMonth+1, currentDay + 1);
  // }
  const checkOutDate = nextDate.getFullYear() + '-' + String(nextDate.getMonth() + 1).padStart(2, '0') + "-" + String(nextDate.getDate()).padStart(2, '0');
  const [selectedDate, handleDateChange] = useState<any>([urlCheckInDate ? urlCheckInDate : checkInDate, urlCheckOutDate ? urlCheckOutDate : checkOutDate]);
  const [bookingURL, setBookingURL] = useState<string>('');
  const [bookingURLNationality, setBookingURLNationality] = useState<string>('');
  const [brandInfo, setBrandInfo] = useState<any>();
  useIbeChatWidget(brandID, chainID, brandInfo);
  const [maxChildAge, setMaxChildAge] = useState(17);
  const [loading, setLoading] = useState(false);
  const [isPromotionLoading, setIsPromotionLoading] = useState<boolean>(false);
  const [isBarDataLoading, setIsBarDataLoading] = useState<boolean>(false);
  const [barData, setBarData] = useState<any>([]);
  const [barCurrency, setBarCurrency] = useState<string>("");
  const [demandData, setDemandData] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>([{ date: null, fetch: true }]);
  const [openGuest, setOpenGuest] = useState(false);
  const [openClass, setOpenClass] = useState(false);
  const [isPageLoaded, setPageLoaded] = useState(false);
  const [dlysxParam, setDlysxParam] = useState<any>();
  const params = window.location.href.split('?');
  const [destinationOptionList, setDestinationOptionList] = useState<any>([]);
  const [isAddRoomExpanded, setIsAddRoomExpanded] = useState(false);
  const [locationList, setLocationList] = useState<any>([]);
  const [promotionData, setPromotionData] = useState<any>([{
    promoCatId: PromotionEnum.RegularRate,
    promoCatName: "Regular Rate",
    description: 'These are the most affordable rate currently offered for booking a hotel room.',
    key: PromotionEnumKey.RegularRate
  }]);
  const { t } = useTranslation();
  const initialToastObj = useMemo(() => ({
    toastState: false,
    toastMessage: t("widget", "destinationIsRequired", locale)
  }), [t]);

  const [toastObj, setToastObj] = useState(initialToastObj);

  const parseDate = (currentDate: any) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const getNextDate = (dateInput: any) => {
    // Handle different input types
    if (!dateInput) return new Date();

    let currentDate: Date;

    if (dateInput instanceof Date) {
      currentDate = new Date(dateInput);
    } else if (typeof dateInput === 'string') {
      // Handle string input - parse directly to avoid timezone issues
      if (dateInput.includes('-')) {
        // It's in YYYY-MM-DD format
        const parts = dateInput.split('-');
        if (parts.length === 3) {
          const year = parseInt(parts[0]);
          const month = parseInt(parts[1]) - 1; // months are zero-indexed
          const day = parseInt(parts[2]);
          currentDate = new Date(year, month, day);
        } else {
          currentDate = new Date(dateInput);
        }
      } else {
        // It's already a date string like "Sun Oct 12 2025 12:00:00 GMT+0530"
        currentDate = new Date(dateInput);
      }
    } else {
      // Handle other types
      currentDate = new Date(dateInput);
    }

    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);
    return nextDate;
  }

  const formSchema = useMemo(() => ({
    chainID: chainID,
    brandID: brandID,
    destination: destination ? destination : { id: '', location: '', type: 0 },
    checkInDate: parseDateISOFormat(selectedDate[0]),
    checkOutDate: stayType === StayType.DAY_USE ? parseDateISOFormat(getNextDate(selectedDate[0])) : parseDateISOFormat(selectedDate[1]), // For day use, checkout is next day after checkin
    stayType: stayType,
    guest: [...guest],
    promotion: {
      promotionType: promotion?.promotionType || PromotionEnumKey.RegularRate,
      promotionCode1: promotion?.promotionCode1 || '',
      promotionCode2: promotion?.promotionCode2 || '',
    }
  }), [chainID, brandID, destination, selectedDate, stayType, guest, promotion]);


  function getLastDateOfNextMonth(dateStr: any) {
    // Handle different input types
    if (!dateStr) return '';

    let date: Date;
    if (typeof dateStr === 'string') {
      // Parse date string directly to avoid timezone issues
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // months are zero-indexed
        const day = parseInt(parts[2]);
        date = new Date(year, month, day);
      } else {
        date = new Date(dateStr);
      }
    } else {
      date = new Date(dateStr);
    }

    let year = date.getFullYear();
    let month = date.getMonth();
    let nextMonth = month + 2;
    if (nextMonth > 11) {
      year += 1;
      nextMonth -= 12;
    }
    let firstDayOfNextMonth: any = new Date(year, nextMonth, 1);
    let lastDayOfNextMonth: any = new Date(firstDayOfNextMonth - 1);

    // Format manually to avoid timezone conversion
    const formattedYear = lastDayOfNextMonth.getFullYear();
    const formattedMonth = String(lastDayOfNextMonth.getMonth() + 1).padStart(2, '0');
    const formattedDay = String(lastDayOfNextMonth.getDate()).padStart(2, '0');
    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
  }

  function increaseDateByTwoMonths(dateString: any) {
    // Handle different input types
    if (!dateString) return '';

    let parts: string[];
    if (typeof dateString === 'string') {
      parts = dateString.split('-');
    } else {
      // Handle Date objects or other types
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      parts = [year.toString(), month, day];
    }

    if (parts.length !== 3) return '';

    var year = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var day = parseInt(parts[2]);
    month += 2;
    if (month > 12) {
      year += Math.floor((month - 1) / 12);
      month = (month - 1) % 12 + 1;
    }
    var isLeapYear = (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
    var daysInMonth = [31, (isLeapYear ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day > daysInMonth[month - 1]) {
      day = daysInMonth[month - 1];
    }
    var newDateString = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    return newDateString;
  }

  const isNationalityRequiredForBar = () =>
    isNationalityEnabled && nationalityData?.length > 0;

  const canFetchBarData = () => {
    if (formValues?.destination?.type !== 2 || !formValues?.destination?.id) {
      return false;
    }
    if (isNationalityRequiredForBar() && !selectedNationality) {
      return false;
    }
    return true;
  };

  const fetchBarData = async () => {
    if (!canFetchBarData()) {
      return;
    }

    let _startDate = startDate[0];
    if (formValues?.destination?.type == 2 && formValues?.destination?.id && IsFeatureEnabled(Features.DEMAND_CALENDAR) && _startDate?.fetch && !isBarDataLoading) {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();
      setIsBarDataLoading(true);
      const today = _startDate?.date ? new Date(`${_startDate?.date}T00:00:00Z`) : new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/rate/getPropertyBAR`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          propertyId: formValues?.destination?.type == 2 ? formValues?.destination?.id : '',
          checkIn: formattedDate(formValues?.checkInDate),
          checkOut: formattedDate(formValues?.checkOutDate),
          startDate: `${year}-${month}-${day}`,
          endDate: selectedDate.length > 0 && Date.parse(selectedDate[1]) >= today.setMonth(today.getMonth() + 2) ? getLastDateOfNextMonth(selectedDate[1]) : increaseDateByTwoMonths(`${year}-${month}-${day}`),
          channels: [`49e159c6-d666-4330-9c97-d226cd26ae03`],
          nationalityId: selectedNationality?.nationalityId
        })
      })
        .then((response: any) => response.json())
        .then((data) => {
          if (data?.status && data.body?.propertyDateBARs && data.body?.propertyDateBARs.length > 0) {
            let _barData = [...barData, ...data.body?.propertyDateBARs];
            setBarData(_barData)
            if (data.body?.currency != null) {
              setBarCurrency(data.body?.currency);
            }
          } else {
            //console.logg({ data });
          }
          setIsBarDataLoading(false)
        })
    }
  }

  function getCityCode(cityName: string) {
    const lowerCaseCityName = cityName.toLowerCase();
    for (const city of cityCodeMapping) {
      const lowerCaseCity = city.name.toLowerCase();
      if (lowerCaseCity === lowerCaseCityName) {
        return city.code;
      }
    }
    return null;
  }

  const fetchDemandData = async () => {
    if ((formValues?.destination?.type == 1 || formValues?.destination?.type == 2) && formValues?.destination?.location && IsFeatureEnabled(Features.DEMAND_CALENDAR)) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const city = formValues?.destination?.type == 1 ? formValues?.destination?.location : destinationOptionList?.filter((ele: any) => ele?.name == formValues?.destination?.location)[0]?.city;
      const cityCode = getCityCode(city ? city : cityCodeDemand);
      const demandBody = {
        startDate: `${`${year}-${month}-${day}`}`,
        endDate: increaseDateByTwoMonths(increaseDateByTwoMonths(`${`${year}-${month}-${day}`}`)),
        cityCode: cityCode
      }
      if (cityCode != null) {
        const response = await fetch(`${process.env.REACT_APP_DOMAIN}/api/13f5ee5a-c5c3-4230-9f57-c9f487896f60_EXT`, {
          method: 'POST',
          body: JSON.stringify({ demandBody: demandBody, reqType: 'POST' })
        });

        if (response.ok) {
          let res = await response.json();
          let result = JSON.parse(res.data);
          let _demandData: any;
          if (result.statusCode == 200) {
            _demandData = [...result?.Data?.city];
            setDemandData(_demandData);
          }
        } else {
          //console.logg({ response });
        }

      }
    }
  }

  useEffect(() => {
    setLoading(true);
    if ((parent as any)?.window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv")) {
      (parent as any).window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv").style.minHeight = "600px";
      (parent as any).window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv").style.height = "auto";
    }
    const fetchBrandInfo = async () => {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();
      ////console.logg('process.env', process.env)

      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Search/getBrandInfo?brandID=${brandID}`)
        .then((response: any) => response.json())
        .then(async (data) => {
          if (data?.status) {
            ////console.logg({data});
            setBookingURL(data?.body?.bookingURL)
            setBrandInfo(data?.body);
            if(data?.body?.isNationalityEnabled) {
              setBookingURLNationality(data?.body?.nationality[0]?.natitonalityBookingUrl);
            }
            setIsDayBookingEnabled(!!data?.body?.isDayBookingEnabled);
            const nationalityEnabled = !!data?.body?.isNationalityEnabled;
            setIsNationalityEnabled(nationalityEnabled);
            const nationalities: INationality[] = Array.isArray(data?.body?.nationality) ? data?.body?.nationality : [];
            if (nationalityEnabled && nationalities.length > 0) {
              const options = await resolveNationalityOptions(IBE_lOCATION_API, nationalities, brandID, chainID);
              setNationalityData(options);
            } else {
              setNationalityData(nationalities);
            }
          } else {
            setIsDayBookingEnabled(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching brand info:', error);
          setIsDayBookingEnabled(false);
        })
        .finally(() => {
          setIsDayBookingLoading(false);
        })
    }
    fetchBrandInfo();
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchPromotionData = async () => {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();
      ////console.logg('process.env', process.env)
      setIsPromotionLoading(true);
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Promotions/getPromotionsCategories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          brandID: brandID,
          chainID: chainID,
          country: formValues?.destination?.type === 0 ? formValues?.destination?.id : '',
          city: formValues?.destination?.type === 1 ? formValues?.destination?.id : '',
          propertyId: formValues?.destination?.type === 2 ? formValues?.destination?.id : '',
          checkInDate: formattedDate(formValues?.checkInDate),
          checkOutDate: formattedDate(formValues?.checkOutDate)
        })
      })
        .then((response: any) => response.json())
        .then((data) => {
          setIsPromotionLoading(false)
          if (data?.status) {
            setPromotionData(data?.body)
          }
          else {
            setPromotionData([]);
          }
        })
    }
    if (formValues?.destination?.id) {
      fetchPromotionData();
    }
  }, [formValues?.destination?.id, formValues?.destination?.type, formValues?.checkInDate, formValues?.checkOutDate]);

  useEffect(() => {
    setDemandData([]);
    setBarData([]);
    setBarCurrency("");
    setStartDate([{ date: null, fetch: true }]);
    if (formValues?.destination?.type == 2 || formValues?.destination?.type == 1) {
      fetchDemandData();
      if (formValues?.destination?.type == 2 && canFetchBarData()) {
        fetchBarData();
      }
    }
  }, [formValues?.destination?.id, formValues?.destination?.type]);

  useEffect(() => {
    if (!isNationalityRequiredForBar()) {
      return;
    }

    setBarData([]);
    setBarCurrency("");
    setStartDate([{ date: null, fetch: true }]);

    if (formValues?.destination?.type === 2 && formValues?.destination?.id && selectedNationality) {
      fetchBarData();
    }
  }, [selectedNationality?.nationalityId]);

  useEffect(() => {
    if (!isBarDataLoading) {
      if (startDate.length > 1) {
        let _startDate = [...startDate];
        //console.logg(_startDate.shift());
        setStartDate(_startDate);
      } else {
        setStartDate([{ date: startDate[0]?.date, fetch: false }]);
      }
    }
  }, [isBarDataLoading])

  useEffect(() => {
    fetchBarData();
  }, [startDate.length, startDate[0]?.date, startDate[0]?.fetch]);

  const handleNationalityChange = (nationality: INationality | null) => {
    setSelectedNationality(nationality);
    if (nationality) {
      setNationalityError(false);
    }
  }

  // Validates the mandatory nationality selection and returns the booking URL to redirect to
  const resolveNationalityBooking = (values: any): { valid: boolean; url: any; code?: string } => {
    const isNationalityRequired = isNationalityEnabled && nationalityData?.length > 0;
    // Nationality is mandatory (only once a destination is selected, so destination validation stays first)
    if (isNationalityRequired && values?.destination?.id && !selectedNationality) {
      setNationalityError(true);
      return { valid: false, url: bookingURL };
    }
    setNationalityError(false);
    // When a nationality is selected, redirect to its dedicated booking URL
    const url = isNationalityRequired && selectedNationality?.nationalityId === '0'
      ? bookingURLNationality
      : bookingURL;
    // Attach the selected nationality code (nc) only when nationality is enabled and selected
    const code = isNationalityRequired && selectedNationality ? selectedNationality.nationalityId : undefined;
    return { valid: true, url, code };
  }

  const bookNowHandlerMobile = (values: any) => {
    if (!isAddRoomExpanded) {
      const nationalityBooking = resolveNationalityBooking(values);
      if (!nationalityBooking.valid) return;
      bookNowHandler(values, setToastObj, promotionData, destinationOptionList, nationalityBooking.url, brandID, chainID, params, openinNewTab, dlysxParam, locale, nationalityBooking.code);
    }
  }

  const onClickbookNowHandler = (values: any, fn: any = {}, setFieldTouched: any) => {
    if (!isAddRoomExpanded) {
      const nationalityBooking = resolveNationalityBooking(values);
      if (!nationalityBooking.valid) return;
      bookNowHandler(values, setToastObj, promotionData, destinationOptionList, nationalityBooking.url, brandID, chainID, params, openinNewTab, dlysxParam, locale, nationalityBooking.code);
    }
  };

  const formattedDate = (date: any) => {
    const [year, month, day] = date?.split('-') ?? [];
    if (year == null || month == null || day == null) return date;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const createQueryString = (data: any) => {
    return Object.keys(data).filter(x => data[x] !== false).map(key => {
      let val = data[key]
      if (val === false) return ''
      if (val !== null && typeof val === 'object' && Object.keys(val).length > 0 && !Array.isArray(val)) val = createQueryString(val)
      if (key == 'chainID' || key == 'brandID') {
        return;
      }
      if (key == 'destination') {
        var newVal = val.split('&');
        val = `${newVal[0]}&${newVal[2]}`;
      }
      if (key == 'checkInDate' || key == 'checkOutDate') {
        val = formattedDate(val);
      }
      if (key == 'stayType') {
        val = val; // Keep stayType as is
      }
      if (Array.isArray(val) && (key === 'guest')) {
        const arrayParams = new Array();
        val.forEach(obj => {
          switch (obj?.roomCount) {
            case 1: {
              if (obj.adultCount > 0)
                arrayParams.push('ac1=' + obj.adultCount);
              if (obj.childCount > 0) {
                arrayParams.push('cc1=' + obj.childCount);
                // Add child ages if available and not empty
                if (obj.childAges && Array.isArray(obj.childAges) && obj.childAges.length > 0) {
                  const ages = obj.childAges.filter((age: number | null) => age !== null && age !== undefined);
                  if (ages.length > 0) {
                    arrayParams.push('ca1=[' + ages.join(':') + ']');
                  }
                }
              }
              break;
            }
            case 2: {
              if (obj.adultCount > 0)
                arrayParams.push('ac2=' + obj.adultCount);
              if (obj.childCount > 0) {
                arrayParams.push('cc2=' + obj.childCount);
                if (obj.childAges && Array.isArray(obj.childAges) && obj.childAges.length > 0) {
                  const ages = obj.childAges.filter((age: number | null) => age !== null && age !== undefined);
                  if (ages.length > 0) {
                    arrayParams.push('ca2=[' + ages.join(':') + ']');
                  }
                }
              }
              break;
            }
            case 3: {
              if (obj.adultCount > 0)
                arrayParams.push('ac3=' + obj.adultCount);
              if (obj.childCount > 0) {
                arrayParams.push('cc3=' + obj.childCount);
                if (obj.childAges && Array.isArray(obj.childAges) && obj.childAges.length > 0) {
                  const ages = obj.childAges.filter((age: number | null) => age !== null && age !== undefined);
                  if (ages.length > 0) {
                    arrayParams.push('ca3=[' + ages.join(':') + ']');
                  }
                }
              }
              break;
            }
            case 4: {
              if (obj.adultCount > 0)
                arrayParams.push('ac4=' + obj.adultCount);
              if (obj.childCount > 0) {
                arrayParams.push('cc4=' + obj.childCount);
                if (obj.childAges && Array.isArray(obj.childAges) && obj.childAges.length > 0) {
                  const ages = obj.childAges.filter((age: number | null) => age !== null && age !== undefined);
                  if (ages.length > 0) {
                    arrayParams.push('ca4=[' + ages.join(':') + ']');
                  }
                }
              }
              break;
            }
            case 5: {
              if (obj.adultCount > 0)
                arrayParams.push('ac5=' + obj.adultCount);
              if (obj.childCount > 0) {
                arrayParams.push('cc5=' + obj.childCount);
                if (obj.childAges && Array.isArray(obj.childAges) && obj.childAges.length > 0) {
                  const ages = obj.childAges.filter((age: number | null) => age !== null && age !== undefined);
                  if (ages.length > 0) {
                    arrayParams.push('ca5=[' + ages.join(':') + ']');
                  }
                }
              }
              break;
            }

            default:
              break;
          }
        });
        val = `${arrayParams}`;
        return `${key}=[${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}]`
      }
      return `${key}=${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}`
    }).join('&')
  }

  const DisplayingErrorMessagesSchema = useMemo(() => yup.object().shape({
    checkInDate: yup.date().nullable().typeError(t("widget", "checkInIsRequired", locale)).required(t("widget", "checkInIsRequired", locale)),
    checkOutDate: stayType === StayType.DAY_USE ? yup.date().nullable() : yup.date().nullable().required(t("widget", "checkOutIsRequired", locale)).typeError(t("widget", "checkOutIsRequired", locale))
  }), [stayType, t]);

  const updateValue = (value: any, type: any, setFieldValue: any, widgetValues: any, touched: any) => {
    setPageLoaded(true);
    touched[type] = true;
    if (isNaN(Date.parse(value)) == false) {
      var v = parseDate(new Date(value))
      setFieldValue(type, v, true);
    }
    else {
      setFieldValue(type, '', true);
    }
    if (type === 'dateRange') {
      var updatedCheckInValue;
      var updatedCheckOutValue;
      if (isNaN(Date.parse(value.startDate._d)) === false) {
        updatedCheckInValue = parseDate(new Date(value.startDate._d));
        setFieldValue('checkInDate', updatedCheckInValue, true);
      }

      // Handle checkout date based on stay type
      if (stayType === StayType.DAY_USE) {
        // For day use, checkout is next day after checkin
        if (updatedCheckInValue) {
          updatedCheckOutValue = parseDate(getNextDate(updatedCheckInValue));
          setFieldValue('checkOutDate', updatedCheckOutValue, true);
        }
      } else {
        // For overnight stay, handle normal checkout logic
        if (value?.endDate?._d && isNaN(Date.parse(value.endDate?._d)) === false) {
          if (Date.parse(value.endDate._d) === Date.parse(value.startDate._d)) {
            const nextDate = parseDate(getNextDate(value.startDate._i));
            setFieldValue('checkOutDate', nextDate, true);
            updatedCheckOutValue = nextDate;
          }
          else {
            updatedCheckOutValue = parseDate(new Date(value.endDate._d));
            setFieldValue('checkOutDate', updatedCheckOutValue, true);
          }
        }
        else {
          const nextDate = parseDate(getNextDate(value.startDate._d));
          setFieldValue('checkOutDate', nextDate, true);
          updatedCheckOutValue = nextDate;
        }
      }
      if (updatedCheckInValue && updatedCheckOutValue) {
        handleDateChange([updatedCheckInValue, updatedCheckOutValue]);
      }
    }
  }



  const widgetControl = (initialValues: any, errors: any, handleSubmit: any, touched: any, values: { destination: any; guest: any; }, setFieldValue: any, isValid: any, setFieldError: any, setFieldTouched: any) => {
    //console.logg(locationList)
    const isDayBookingActive = isModify ? locationList?.find((x: any) => x.propertyId === values?.destination?.id || x.cityId === values?.destination?.id)?.isDayBookingEnabled : true
    const color = (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477 !important' : `${booknowbuttoncolor} !important`
    const handleStayTypeChange = (newStayType: any, setFieldValue: any, setFieldError: any) => {
      if (newStayType === StayType.DAY_USE && !isDayBookingActive) {
        return;
      }
      if (newStayType !== null) {
        setStayType(newStayType);
        setFieldValue("stayType", newStayType, true);
        setDestinationOptionList([]); // Clear destination list to force refetch

        // When switching to day use, set checkout date to next day after checkin
        if (newStayType === StayType.DAY_USE) {
          const nextDate = parseDateISOFormat(getNextDate(selectedDate[0]));
          setFieldValue('checkOutDate', nextDate, true);
        } else {
          // When switching to overnight, set checkout to next day if it's same as checkin
          if (selectedDate[0] === selectedDate[1]) {
            const nextDate = parseDateISOFormat(getNextDate(selectedDate[0]));
            setFieldValue('checkOutDate', nextDate, true);
            handleDateChange([selectedDate[0], nextDate]);
          }
        }
      }
    }

    const mobileSearchControl = (
      <MobileSearchControl
        defaultPropCode={defaultPropCode}
        disableSearchControl={disableSearchControl}
        setDlysxParam={setDlysxParam}
        setMaxChildAge={setMaxChildAge}
        brandID={brandID}
        chainID={chainID}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
        initialValues={initialValues}
        dest={values?.destination}
        fontColor={widgetFontColor}
        booknowbuttoncolor={booknowbuttoncolor}
        booknowbuttonfontcolor={widgetSearchFontButtonColor}
        buttonHoverFontColor={widgetSearchFontHoverStateColor}
        values={values}
        booknowbuttonhovercolor={booknowbuttonhovercolor}
        setPageLoaded={setPageLoaded}
        setDestinationOptionList={setDestinationOptionList}
        isDayBooking={stayType === StayType.DAY_USE}
        setFieldError={setFieldError}
        setLocationList={setLocationList}
        locale={locale}
        showDestinationSearch={showDestinationSearch}
      />
    );

    return (
      <form onSubmit={handleSubmit}>
        <Box component="div" className="destinationCheckInCheckOut">
          <Toast toastState={toastObj.toastState} setToastState={setToastObj} toastMessage={toastObj.toastMessage} locale={locale}></Toast>

          {/* Stay Type Selection - Only show if day booking is enabled */}
          {isDayBookingEnabled && !isDayBookingLoading && (
            <Box component="div" className="stayTypeSelection" sx={{
              backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`,
              color: widgetFontColor ? widgetFontColor : "#fff"
            }}>
              <ToggleButtonGroup
                value={stayType}
                exclusive
                onChange={(event, newStayType) => handleStayTypeChange(newStayType, setFieldValue, setFieldError)}
                sx={{
                  width: '100%',
                  '& .MuiToggleButton-root': {
                    flex: 1,
                    border: `1px solid ${widgetSearchFontButtonColor || "#fff"}`,
                    color: (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff !important' : `${widgetSearchFontButtonColor} !important`,
                    '&.Mui-selected': {
                      color: (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477 !important' : `${booknowbuttoncolor} !important`,
                      border: `1px solid ${widgetFontColor || "#fff"}`,
                      backgroundColor: (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff !important' : `${widgetSearchFontButtonColor} !important`,
                      '&:hover': {
                        backgroundColor: '#fff',
                      }
                    },
                  }
                }}
              >
                <ToggleButton style={{ fontSize: '15px' }} className='over-night' value={StayType.OVERNIGHT}>
                  Overnight Stay
                </ToggleButton>
                <ToggleButton style={{ fontSize: '15px' }} className={`day-use ${isDayBookingActive ? '' : 'opacity-50 hover:cursor-default'}`} value={StayType.DAY_USE}>
                  Day Use
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          )}
          {showDestinationSearch ? (
            <Box component="div" className="mobileDestination" style={{ backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`, color: widgetFontColor ? widgetFontColor : "#fff", paddingRight: locale == "ar" ? "14px" : "0px" }}>
              <Box component="div" sx={{ display: 'inline-block', width: "100%" }}>
                <Typography variant="h6" style={{ color: widgetFontColor ? widgetFontColor : "#fff", textTransform: "uppercase" }}>{t("widget", "destination", locale)}</Typography>
                <Box component="div" sx={{ display: 'flex', justifyContent: "space-between", color: widgetFontColor ? widgetFontColor : "#fff" }}>
                  {mobileSearchControl}
                  <LocationOnIcon sx={{ display: 'inline-block', float: 'right', margin: '5px 15px 0px 0px', fontSize: '24px', opacity: '100%', color: widgetFontColor && widgetFontColor != 'null' ? `${widgetFontColor} !important` : "#fff !important" }} />
                </Box>
              </Box>
            </Box>
          ) : (
            mobileSearchControl
          )}
          <Box component="div" className="checkIncheckOut" sx={{ backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`, backgroundColor: "#526781", mt: "4px", borderRadius: '6pt', color: widgetFontColor ? widgetFontColor : "#fff" }}>
            <RangeDateControl
              selectedDate={stayType === StayType.DAY_USE ? [selectedDate[0]] : selectedDate}
              handleDateChange={(value: any) => updateValue(value, 'dateRange', setFieldValue, values, touched)}
              isMobile={true}
              fontColor={widgetFontColor}
              booknowbuttoncolor={booknowbuttoncolor}
              booknowbuttonfontcolor={widgetSearchFontButtonColor}
              buttonHoverFontColor={widgetSearchFontHoverStateColor}
              booknowbuttonhovercolor={booknowbuttonhovercolor}
              barData={barData}
              navStartDate={startDate}
              setStartDate={setStartDate}
              demandData={demandData}
              barCurrency={barCurrency}
              isDemandCalendar={IsFeatureEnabled(Features.DEMAND_CALENDAR) ? true : false}
              destinationType={values?.destination}
              propertyID={formValues?.destination?.type == 2 ? formValues?.destination?.id : destination?.id ? destination?.id : ''}
              currencyMappingData={currencyMappingData}
              isMultiCurrencyFFEnable={isMultiCurrencyFFEnable}
              preferredCurrency={preferredCurrency}
              hideCheckout={stayType === StayType.DAY_USE}
              locale={locale}
            />
          </Box>
          {showGuest && (
            <Box component="div" className="mobileTraveller" sx={{ backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`, color: widgetFontColor ? widgetFontColor : "#fff", paddingRight: locale == "ar" ? "14px" : "0px" }}>
              <Box component="div">
                <Typography variant="h6" style={{ color: widgetFontColor ? widgetFontColor : "#fff", textTransform:"uppercase" }}>{t("widget", "guests", locale)}</Typography>
                <NewMobileAddRoom widgetValues={values} openGuest={openGuest} setOpenGuest={setOpenGuest} setFieldValue={setFieldValue} maxChildAge={maxChildAge} initialValues={initialValues} guestObj={values?.guest} fontColor={widgetFontColor} booknowbuttoncolor={booknowbuttoncolor} booknowbuttonhovercolor={booknowbuttonhovercolor} setIsAddRoomExpanded={setIsAddRoomExpanded} brandId={brandID} locale={locale} />
              </Box>
            </Box>
          )}
          {isNationalityEnabled && nationalityData?.length > 0 && (
            <Box component="div" className="mobileNationality" sx={{ backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`, color: widgetFontColor ? widgetFontColor : "#fff", paddingRight: locale == "ar" ? "14px" : "0px" }}>
              <Box component="div">
                <NationalityDropdown
                  nationalityData={nationalityData}
                  selectedNationality={selectedNationality}
                  onChange={handleNationalityChange}
                  fontColor={widgetFontColor}
                  booknowbuttoncolor={booknowbuttoncolor}
                  locale={locale}
                  isMobile={true}
                  hasError={nationalityError}
                  onClearError={() => setNationalityError(false)}
                />
              </Box>
            </Box>
          )}
          {showSelectedRate && (
            <Box component="div" className="mobileHotelClass" sx={{ backgroundImage: `linear-gradient(${backgroundColor1}, ${backgroundColor2})`, color: widgetFontColor ? widgetFontColor : "#fff", paddingRight: locale == "ar" ? "14px" : "0px" }}
              onClick={() => {
                if (values.destination?.location && !isPromotionLoading) {
                  setOpenClass(true)
                  if ((parent as any)?.changeIframeHeight) {
                    if (parent.window.document.getElementById("86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe") != null) {
                      (parent as any)?.changeIframeHeight(750);
                    }
                  }
                }
              }}
            >
              <Box component="div">
                {/* <Typography variant="h6" style={{ color: widgetFontColor ? widgetFontColor : "#fff" , textTransform: "uppercase" }}>{t("widget", "selectedRate", locale)}</Typography> */}
                <PromotionMobile
                  setFieldValue={setFieldValue}
                  openClass={openClass}
                  setOpenClass={setOpenClass}
                  widgetValues={values}
                  isDisable={values.destination?.location}
                  values={values}
                  fontColor={widgetFontColor}
                  booknowbuttoncolor={booknowbuttoncolor}
                  booknowbuttonhovercolor={booknowbuttonhovercolor}
                  buttonFontColor={widgetSearchFontButtonColor}
                  buttonHoverFontColor={widgetSearchFontHoverStateColor}
                  promotionData={promotionData}
                  isPageLoaded={isPageLoaded}
                  locale={locale}
                />
              </Box>
            </Box>
          )}
          <Box component="div" className="bookNow">
            <Button
              disabled={bookingURL === '' || bookingURL == null || isAddRoomExpanded}
              sx={{
                textTransform: "uppercase",
                backgroundColor: (booknowbuttoncolor == undefined || booknowbuttoncolor == null || booknowbuttoncolor == 'null') ? '#546477 !important' : `${booknowbuttoncolor} !important`,
                color: (widgetSearchFontButtonColor == undefined || widgetSearchFontButtonColor == null || widgetSearchFontButtonColor == 'null') ? '#fff !important' : `${widgetSearchFontButtonColor} !important`,
                width: '192px',
                height: '70px',
              }}
              style={{ marginBottom: "20px" }}
              type="button"
              onClick={() => onClickbookNowHandler(values, setFieldError, setFieldTouched)}
            >
              {showSearch ? t("widget", "search", locale) : t("widget", "bookNow", locale)}
            </Button>
          </Box>
        </Box>
      </form >
    )
  }

  // Sync Formik values to local state without updating during render
  const FormikValuesObserver = () => {
    const { values } = useFormikContext<any>();
    const prevValuesRef = useRef<any>(undefined);

    useEffect(() => {
      // Only update if values have actually changed
      if (JSON.stringify(prevValuesRef.current) !== JSON.stringify(values)) {
        prevValuesRef.current = values;
        setFormValues(values);
      }
    }, [values]);
    return null;
  }

  return (
    <Box>
      <Formik initialValues={formSchema} validationSchema={DisplayingErrorMessagesSchema} onSubmit={bookNowHandlerMobile}>
        {({ initialValues, errors, handleSubmit, touched, values, setFieldValue, isValid, setFieldError, setFieldTouched }) => (
          <>
            <FormikValuesObserver />
            {widgetControl(initialValues, errors, handleSubmit, touched, values, setFieldValue, isValid, setFieldError, setFieldTouched)}
          </>
        )}
      </Formik>
    </Box>
  )
}


export default ReservationWidgetMobile;